import { SearchFieldKeys, TableColumn } from "@sso/types";

import { BilledOperationOrganisationSummaryKeys } from "../../types/billedOperationOrganisationSummary";


export const billedOperationOrganisationSummaryTableColumns: TableColumn<BilledOperationOrganisationSummaryKeys>[] =[
    {
        name: "Organisation",
        field: BilledOperationOrganisationSummaryKeys.ORGANISATION_NAME,
        sortable: true,
        search: { type: SearchFieldKeys.TEXT},
    },
    {
        name: "Last month total",
        field: BilledOperationOrganisationSummaryKeys.LAST_MONTH_TOTAL,
        sortable: true
    },
    {
        name: "Current month to date total",
        field: BilledOperationOrganisationSummaryKeys.CURRENT_MONTH_TO_DATE_TOTAL,
        sortable: true
    },
];